import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["notesModal"];

  connect() {

  }

  toggleNotesModal(e) {
    if (e.target.element == "A") {
      e.preventDefault();
    }
    this.notesModalTarget.classList.toggle("hidden");
  }

}